import { SET_ATTRIBUTION, SET_HAS_PARTNER_REFERRER } from '../action-types';

// @ts-expect-error - Automatic, Please fix when editing this file
const setAttribution = (attributionId) => ({ attributionId, type: SET_ATTRIBUTION });

// @ts-expect-error - Automatic, Please fix when editing this file
const setHasPartnerReferrer = (hasPartnerReferrer) => ({ hasPartnerReferrer, type: SET_HAS_PARTNER_REFERRER });

export default { setAttribution, setHasPartnerReferrer };
